import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { ShiftRequestDto } from '../models/shift-request.model';

export interface IShiftRequestService {
  getShiftRequestById(id: string): Observable<ShiftRequestDto>;
}

export const SHIFT_REQUEST_SERVICE = new InjectionToken<IShiftRequestService>(
  'SHIFT_REQUEST_SERVICE'
);
